export const DATE_FIELDS = ['start_date', 'end_date'];

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const str = String(dateString);
  const isoMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]}`;
  }
  const date = new Date(str);
  if (isNaN(date.getTime())) return str;
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const translateField = (fieldName) => {
  const translations = {
    'unit_id': 'Unidade',
    'schedule_payment_type_id': 'Forma Cobrança',
    'surgeon_id': 'Cirurgião',
    'start_date': 'Data Início',
    'end_date': 'Data Fim',
    'bplid': 'BPL ID',
    'businessUnit': 'Business Unit'
  };
  return translations[fieldName] || fieldName;
};

export const translateAction = (action) => {
  const translations = {
    'CREATE': 'Criação',
    'UPDATE': 'Atualização',
    'DELETE': 'Exclusão'
  };
  return translations[action] || action;
};
